import Vue from "vue";
import Vuex from "vuex";
import chats from "./modules/chats/index.js";

import lang from "./modules/lang/index.js";
import sideNav from "./modules/sideNav/index.js";
import auth from "./modules/Auth/index.js";
import theme from "./modules/Theme/index.js";
import socket from "./modules/SocketGetters/index.js";
import notifications from "./modules/notifications/index.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    lang_module: lang,
    sideNav_module: sideNav,
    auth_module: auth,
    theme_module: theme,
    socket_module: socket,
    countries: [],
    chat_module: chats,
    notifications_module: notifications,
  },

  state() {
    return {
      offerTypeEdit: "",
      resizeEventExisit: false,
      permissions: JSON.parse(localStorage.getItem("Zoz_permissions")) || [],
    };
  },
  getters: {
    resizeEventExisit(state) {
      return state.resizeEventExisit;
    },
    offerTypeEdit(state) {
      return state.offerTypeEdit;
    },
    countries(state) {
      return state.countries;
    },
    permissions(state) {
      return state.permissions;
    },
  },
  mutations: {
    changeRessizeEvent(state) {
      state.resizeEventExisit = !state.resizeEventExisit;
    },
    offerTypeEdit(state, paylod) {
      state.offerTypeEdit = paylod;
    },
    setCountris(state, paylod) {
      state.countries = paylod;
    },
    setPermissions(state, payload) {
      state.permissions = payload || [];
    },
  },
  actions: {},
});
